import { useState } from 'react';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

// import { LoadingScreen } from '../LoadingScreen'
import { __DEV__ } from '@apollo/client/utilities/globals';
import { ApolloProvider } from '@apollo/client';
import { ConfigProvider, theme as antdTheme } from 'antd';
import esES from 'antd/locale/es_ES';

import apolloClient from '../../constants/apollo';
import { Routing } from './Routing';
import { AuthProvider } from '../../contexts/AuthContext';
import { BranchProvider } from '../../contexts/BranchContext';
import { ToastContainer } from 'react-toastify';
// import { DeviceProvider } from '../../contexts/DeviceContext'
import { MaintenanceScreen } from '../MaintenanceScreen';

import './Main.scss';
import { DeviceProvider } from '../../contexts/DeviceContext';
import { ThemeToggle } from '../../components/ThemeToggle';
import { CookieBanner } from '../../components/CookieBanner';
import { useTheme } from '../../contexts/ThemeContext';

const Main = () => {
  if (__DEV__) {
    loadDevMessages();
    loadErrorMessages();
  }

  const manteninance = false;

  const isChrome = !!(window as any).chrome;
  const iOSChrome = window.navigator.userAgent.match('CriOS');

  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  const [browserNoticeDismissed, setBrowserNoticeDismissed] = useState(
    () => localStorage.getItem('mallorcaoposita-browser-notice-dismissed') === 'true'
  );

  const dismissBrowserNotice = () => {
    localStorage.setItem('mallorcaoposita-browser-notice-dismissed', 'true');
    setBrowserNoticeDismissed(true);
  };

  if (manteninance) {
    return <MaintenanceScreen />;
  }

  // ConfigProvider vive aquí, en la raíz, para que TODO el árbol
  // (login, modales, páginas protegidas) reciba el mismo tema y locale.
  // Antes solo lo aplicaba el componente `Screen`, así que el login y
  // los modales fuera de una página quedaban sin tema/locale de Antd.
  return (
    <ConfigProvider
      locale={esES}
      theme={{
        algorithm: isDarkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        components: {
          Pagination: {
            algorithm: true,
            itemBg: isDarkMode ? 'rgb(var(--color-brand-borders))' : '#ffffff'
          }
        }
      }}
    >
      <ApolloProvider client={apolloClient}>
        <ThemeToggle />
        <AuthProvider>
          <DeviceProvider>
            <BranchProvider>
              <ToastContainer />
              <Routing />
            </BranchProvider>
          </DeviceProvider>
        </AuthProvider>
        {!isChrome && !iOSChrome && !browserNoticeDismissed && (
          <div className='chrome'>
            <button
              type="button"
              className="chrome-close"
              onClick={dismissBrowserNotice}
              aria-label="Cerrar aviso"
            >
              ×
            </button>
            <p>Para la mejor experiencia recomendamos usar Google Chrome.</p>
            <a href="https://www.google.com/intl/es_es/chrome/" target="_blank" rel="noreferrer">
              Descargar Google Chrome
            </a>
          </div>
        )}
        <CookieBanner />
      </ApolloProvider>
    </ConfigProvider>
  );
};

export { Main };
